import React, { useState, useEffect, useContext } from 'react';
import { createPortal } from 'react-dom';

import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import { ThemeContext } from '../../store/ThemeProvider';
import { IComponentVote } from '../../component';
import Lucky, { ILuckyProps } from './Lucky';
import { alpha } from '../../utils/color';
import { isIphoneX, getPageSameType } from '../../utils/util';
import usePortalDom from '../hooks/usePortalDom';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import intl from 'react-intl-universal';
import ReactSVG from 'react-svg';

let luckyContainer = window.document.createElement('div');
window.document.body.appendChild(luckyContainer);

const AllForLucky = (props: ILuckyProps) => {
  const { show_result, data, cid } = props;
  const { componentColor, mainColor, h1Color, h2Color } = useContext(
    ThemeContext
  );

  const [realBottom, setRealBottom] = useState(0);
  const [expand, setExpand] = useState(false);

  useEffect(() => {
    // let { template } = window.pageDetail;
    // let paddingBottom = 0;
    // paddingBottom += isIphoneX() ? 22 : 0;
    // let shouldBorder = false;
    // const navigator = getPageSameType(template, [], ['navigator']);
    // if (navigator && navigator.length) {
    //   paddingBottom += 49;
    //   shouldBorder = true;
    // }
    //
    // setRealBottom(paddingBottom - 5);

    if (expand) {
      // disableBodyScroll(window.document.body);
    } else {
      clearAllBodyScrollLocks();
    }

    const onVotePopup = (event: any) => {
      let target_id = event.data;
      if (target_id == cid) {
        setExpand(true);
      }
    };

    const onVoteHide = (event: any) => {
      let target_id = event.data;
      if (target_id == cid) {
        setExpand(false);
      }
    };

    window.addEventListener('lucky_popup', onVotePopup);
    window.addEventListener('lucky_hide', onVoteHide);

    return () => {
      window.removeEventListener('lucky_popup', onVotePopup);
      window.removeEventListener('lucky_hide', onVotePopup);
    };
  }, [expand]);

  const wrapper = usePortalDom({
    parentElement:window.document.getElementById('root-modal')! as HTMLElement
  });

  return wrapper ? createPortal(
    <div
      className="lucky-popup"
      style={{
        display: expand ? 'flex' : 'none'
      }}
    >
      <div className="wrapper">
        <Lucky {...props} />
        <ReactSVG
          src={require('../../svg/x.svg')}
          className="x"
          style={{ fill: alpha('#fff', 1) }}
          onClick={() => {
            setExpand(false);
          }}
        />
      </div>
    </div>,
    wrapper! as HTMLElement
  ) : null;
};

export default inject('rootStore')(observer(AllForLucky));
